// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3mcZR","footer":"ChangeClinic_footer__3Y1sg"};